import * as React from 'react';
import HelmetManager from '../../components/_common/helmet-manager';
import { getText, getConfig, getPageTextsSection } from '../../helpers';
import Breadcrumb from '../../components/breadcrumb';
import DataSetControlsPanel from '../../components/data-controls-panel';
import TileGrid from '../../components/tile-grid';
import SearchEmptyResults from '../../components/search-empty-results';
import SolutionTile from '../../components/tile/solution-tile';
import TileCarousel from '../../components/_common/tile-carousel';
import ProductPreviewSection from '../../components/product-preview-section';
import SearchProvider from '../../components/_providers/search-provider/search-provider';
import Loader from '../../components/_common/loader';
import PageLoaded from '../../components/_common/page-loaded';
import ProductFinderPromo from '../../components/product-finder-promo';

const carouselOptions = getConfig('routes.homepage.carouselOptions');
const metaDataText = getText('pages.dataSets.metaData');

const langCode = getText('langCode');

const featuredDatasets = getText('generic.featuredDatasets');
const genericDatasets = getText('generic.datasets');

const pageText = getConfig('pagetext.datasets');

export default class Datasets extends React.PureComponent<PageProps & DatasetsProps, {}> {
    public render() {
        const { datasets, solutions, filters, featuredData, pageTextsData, keyPage, startDate, bookmarks, bookmarksLoaded } = this.props;
        const hasDatasets = !!datasets.length;
        const hasFilters = !!filters.length;
        const hasSolutions = solutions.length > 0;
        if (!hasDatasets && !hasFilters) return <Loader minHeight="50vh" />;

        const noResultsSection = getPageTextsSection(pageText.noResultSection.noresults, pageTextsData);
        const solutionSection = getPageTextsSection(pageText.solutionSection.header, pageTextsData);
        const productFinderPromo = getPageTextsSection(pageText.productFinderPromo, pageTextsData) as PageSectionData;

        return (
            <article className="page page--noMargin datasets">
                <HelmetManager metaData={metaDataText} />
                <Breadcrumb pathData={[{ text: genericDatasets, url: '/datasets' }]} noMargin />

                {hasDatasets && hasFilters && (
                    <>
                        <SearchProvider
                            type="dataSets"
                            bookmarks={bookmarks}
                            bookmarksLoaded={bookmarksLoaded}
                            filters={filters}
                            urlPath={`/${langCode}/datasets`}
                            render={(response: SearchProviderResponse) => (
                                <>
                                    {response.searchComponent}

                                    <DataSetControlsPanel
                                        selectComponent={response.selectComponent}
                                        filterComponent={response.filterComponent}
                                        lozengeFilterComponent={response.lozengeFilterComponent}
                                        mobileSelectComponent={response.mobileSelectComponent}
                                        mobileFilterComponent={response.mobileFilterComponent}
                                    />

                                    {!response.list.length && response.isSearching && <Loader minHeight="80vh" />}

                                    {!response.list.length && !response.isSearching && (
                                        <>
                                            <SearchEmptyResults
                                                noResultsFound={noResultsSection.title}
                                                message={noResultsSection.content}
                                                otherPages
                                                isModified
                                            />
                                            <hr />
                                            <TileCarousel
                                                dataIds={featuredData}
                                                title={featuredDatasets}
                                                slickOptions={carouselOptions}
                                                showMoreLink
                                            />
                                        </>
                                    )}

                                    {!!response.list.length && <TileGrid list={response.list as DataProfileCard[]} loading={response.isSearching} />}

                                    {hasDatasets &&
                                        hasSolutions &&
                                        response.status === 'loaded-results' &&
                                        response.search === '' &&
                                        response.filterCount === 0 && <PageLoaded keyPage={keyPage} startDate={startDate} />}
                                </>
                            )}
                        />

                        {hasSolutions && (
                            <>
                                <hr />
                                <ProductPreviewSection
                                    title={solutionSection.title}
                                    description={solutionSection.content}
                                    linkText={solutionSection.linkText}
                                    linkUrl={solutionSection.linkUrl}
                                >
                                    {solutions
                                        .map((solution: APISolution) => (
                                            <SolutionTile key={solution.KeyPlatformService} solution={solution} />
                                        ))}
                                </ProductPreviewSection>
                            </>
                        )}
                    </>
                )}
                <ProductFinderPromo {...productFinderPromo} />
            </article>
        );
    }
}
